import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ExternalLink, HorizontalStrip, NamedLink } from '../../../components';
import SectionHeader from './SectionHeader';

import css from './Sections.module.css';

// Items visible per breakpoint; on phones part of the next circle peeks as a swipe cue
const CATEGORIES_PER_VIEW = { base: 2.5, small: 4, medium: 5, large: 6 };
const SKELETON_COUNT = 6;

const SkeletonCircle = () => (
  <div className={css.skeletonItem}>
    <div className={css.skeletonCircle} />
    <div className={css.skeletonText} />
  </div>
);

const ArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

function PopularInstruments(props) {
  const { intl } = props;

  // Shop links and loading state from the content feed (admin)
  const shopLinks = useSelector(state => state.content.shopLinks || []);
  const isLoading = useSelector(state => state.content.contentInProgress);

  // Finished loading with nothing to show: no section
  if (!isLoading && (!shopLinks || shopLinks.length === 0)) {
    return null;
  }

  return (
    <section className={css.section}>
      <HorizontalStrip
        perView={CATEGORIES_PER_VIEW}
        gap={32}
        header={
          <SectionHeader
            eyebrow={intl.formatMessage({ id: 'PopularInstruments.eyebrow' })}
            title={intl.formatMessage({ id: 'PopularInstruments.shopInstrumentsTitle' })}
          />
        }
        headerActions={
          <NamedLink name="SearchPage" className={css.headerLink}>
            {intl.formatMessage({ id: 'PopularInstruments.browseAll' })}
            <ArrowRight />
          </NamedLink>
        }
        prevLabel={intl.formatMessage({ id: 'HorizontalStrip.scrollPrev' })}
        nextLabel={intl.formatMessage({ id: 'HorizontalStrip.scrollNext' })}
        inProgress={isLoading}
        placeholderCount={SKELETON_COUNT}
        renderPlaceholder={() => <SkeletonCircle />}
      >
        {isLoading
          ? null
          : shopLinks.map((item, index) => {
              const linkContent = (
                <>
                  <span className={css.itemImg}>
                    <img src={item.image?.url || ''} alt="" />
                  </span>
                  <span className={css.itemName}>{item.title}</span>
                </>
              );

              // External URLs open as such; internal category routes use the router
              return item.isExternal ? (
                <ExternalLink key={item.id || index} href={item.url} className={css.sliderItem}>
                  {linkContent}
                </ExternalLink>
              ) : (
                <Link key={item.id || index} to={item.url} className={css.sliderItem}>
                  {linkContent}
                </Link>
              );
            })}
      </HorizontalStrip>
    </section>
  );
}

export default PopularInstruments;
